document.addEventListener("DOMContentLoaded", () => {
  const megaMenuLinks = document.querySelectorAll(".mega-menu__link");
  const megaMenuContentList = document.querySelectorAll(".mega-menu__content-list");
  const contentMap = new Map();

  megaMenuContentList.forEach(list => {
    contentMap.set(list.dataset.collectionHandle, list);
  });

  let activeContent = null;

  megaMenuLinks.forEach(link => {
    link.addEventListener("mouseenter", () => {
      const targetHandle = link.dataset.collectionTarget;
      const targetContent = contentMap.get(targetHandle);

      if (!targetContent || targetContent === activeContent) return;

      if (activeContent) activeContent.classList.add("hidden");

      targetContent.classList.remove("hidden");
      activeContent = targetContent;
    });
  });
});
